import React from "react";
import "./DashboardContent.css";
import Floaticons from "./Floaticons";

function DashboardContent() {
  return (
    <>
      <div className="main-banner">
        <img
          src="images/Home/dashboard-banner.png"
          alt="banner"
          className="banner-img"
        />
        <Floaticons />
      </div>
      <div className="dashboard-container">
        <div className="dashboard-wrap">
          {/* <h2 class="visually-hidden">Learning Dashboard</h2>
          <p>
            You can now track your learning progress with a simple click! <br />{" "}
            Check the learning summary, weekly progress data, and trends for
            each track in the below dashboard.
          </p> */}
          {/* <iframe
      title="QIP SAP FSE Learning Report"
      width="100%"
      height="541.25"
      src="https://app.powerbi.com/reportEmbed?reportId=db3e595c-6148-4e79-9244-f8fb5bfe8127&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb"
      frameborder="0"
      allowFullScreen="true"
     ></iframe> */}
          <iframe title="ATCx Dashboard" width="1140" height="541" src="https://app.powerbi.com/reportEmbed?reportId=8a85997c-3484-4608-97ef-23f9c711bc73&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb" frameborder="0" allowFullScreen="true"></iframe>
        </div>
      </div>
    </>
  );
}
export default DashboardContent;
